import React, { useState, useEffect } from 'react';
import EditProfile from './EditProfile';
import HeaderNew from '../HeaderNew.js';
import { BreadcrumbBox } from '../common/Breadcrumb.js';
import { useTranslation } from 'react-i18next';
import service from '../../services/service.js';
import UserService from '../../services/UserService.js';
import swal from 'sweetalert';
import {
    Row,
    Col,
    Button,
    Card,
    Modal,
    Table,
    Alert,
} from "react-bootstrap";


const BulkUserProfile = () => {

    let id = UserService.getUserid();

    const { t } = useTranslation();

    const initialStateId = {
        firstName: '',
        lastName: '',
        email: '',
        mobile: '',
        gender: '',
        dob: '',
        instituteName: '',
        eduQualification: '',
        address: '',
        city: '',
        pincode: '',
        countryId: '',
        stateId: '',
        districtId: '',
        updateBy: '',
        learnerUsername: '',
        firstNameError: '',
        lastNameError: '',
        genderError: '',
        dobError: '',
        mobileError: '',
        eduQualificationError: '',
        instituteNameError: '',
        addressError: '',
        cityError: '',
        pincodeError: '',
        countryIdError: '',
        stateIdError: '',
        districtIdError: '',
        facebookId: '',
        twitterId: '',
        linkedinId: '',
        youtubeId: '',
        skypeId: '',
        facebookIdError: '',
        twitterIdError: '',
        linkedinIdError: '',
        youtubeIdError: '',
        skypeIdError: '',
        status: '',
        registrationType: ''
    };

    const [showSummaryModal, setShowSummaryModal] = useState(false);
    const [getUserDetails, setUserDetails] = useState(initialStateId);

    useEffect(() => {
        getUserById();
    }, [])

    useEffect(() => {
        setShowSummaryModal(!UpdateProfileStatusCheck())
    }, [getUserDetails])

    const UpdateProfileStatusCheck = () => {

        // if (getUserDetails.status == "req-to-update") {

        //     // await swal("Warning", "Update your Profile before enrolling this course", "warning");
        //     return false;
        // }
        // else if (getUserDetails.status == "req-to-approve") {

        //     // await swal("Warning", "Wait till Admin Approves your new profile change", "warning");
        //     return false;
        // }
        // else 
        if (getUserDetails.registrationType == 1 && getUserDetails.status == "emailverified") {
            // await swal("Warning", "Update your Profile before enrolling this course", "warning");
            return false;
        }
        else {
            return true;
        }

    }

    const getUserById = () => {

        service.getUserById(id)
            .then(res => {

                setUserDetails(res.data);

            })
            .catch(err => {

            });
    }

    const onClickModalClose = () => {
        setShowSummaryModal(false);
    }



    return (
        <>
            <div className="edit-profile-page">
                <Modal
                    centered
                    show={showSummaryModal}
                    onHide={onClickModalClose}
                    size="xl"
                >
                    <Modal.Body style={{ padding: "0px" }}>
                        {(<EditProfile id={id} />)}
                    </Modal.Body>
                </Modal>
            </div>
        </>
    );
}

export default BulkUserProfile;